export const PHONE_PREFIX = "+56";
